module.exports = __webpack_public_path__ + "static/img/5-5.a9f19c3.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/4/2/eng/5-5.png
// module id = R25i
// module chunks = 0